/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CashflowDto } from '../models/cashflow-dto';
import { getEffectiveClashflow } from '../fn/cashflow/get-effective-clashflow';
import { GetEffectiveClashflow$Params } from '../fn/cashflow/get-effective-clashflow';
import { getEstimatedClashflow } from '../fn/cashflow/get-estimated-clashflow';
import { GetEstimatedClashflow$Params } from '../fn/cashflow/get-estimated-clashflow';

@Injectable({ providedIn: 'root' })
export class CashflowApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getEstimatedClashflow()` */
  static readonly GetEstimatedClashflowPath = '/v0/Cashflow/estimated';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEstimatedClashflow()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstimatedClashflow$Response(params: GetEstimatedClashflow$Params, context?: HttpContext): Observable<StrictHttpResponse<CashflowDto>> {
    return getEstimatedClashflow(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEstimatedClashflow$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEstimatedClashflow(params: GetEstimatedClashflow$Params, context?: HttpContext): Observable<CashflowDto> {
    return this.getEstimatedClashflow$Response(params, context).pipe(
      map((r: StrictHttpResponse<CashflowDto>): CashflowDto => r.body)
    );
  }

  /** Path part for operation `getEffectiveClashflow()` */
  static readonly GetEffectiveClashflowPath = '/v0/Cashflow/effective';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getEffectiveClashflow()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEffectiveClashflow$Response(params: GetEffectiveClashflow$Params, context?: HttpContext): Observable<StrictHttpResponse<CashflowDto>> {
    return getEffectiveClashflow(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getEffectiveClashflow$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getEffectiveClashflow(params: GetEffectiveClashflow$Params, context?: HttpContext): Observable<CashflowDto> {
    return this.getEffectiveClashflow$Response(params, context).pipe(
      map((r: StrictHttpResponse<CashflowDto>): CashflowDto => r.body)
    );
  }

}
